export enum TipoEndereco{
  Comercial, Residencial
}



export enum Estado {
    NaoInformado,
    Acre,
    Algoas,
    Amapa,
    Amazonas,
    Bahia,
    Ceara,
    DistritoFederal,
    EspíritoSanto,
    Goias,
    Maranhao,
    MatoGrosso,
    MatoGrossoDoSul,
    MinasGerais,
    Para,
    Paraíba,
    Pernambuco,
    Piaui,
    RioDeJaneiro,
    RioGrandeDoNorte,
    RioGrandeDoSul,
    Rondônia,
    Roraima,
    SantaCatarina,
    SaoPaulo,
    Sergipe,
    Tocantins,
}

export enum SiglaUf {

  NãoInformado,
  AC,
  AL,
  AP,
  Am,
  BA,
  CE,
  DF,
  ES,
  GO,
  MA,
  MT,
  MS,
  MG,
  PA,
  PB,
  PE,
  PI,
  RJ,
  RN,
  RS,
  RO,
  RR,
  SC,
  SP,
  SE,
  TO,
}

export enum Pais{
    NaoInformado,
    Albania,
    Alemanha,
    Andorra,
    Angola,
    Anguilla,
    Antartida,
    AntiguaEBarbuda,
    AntilhasHolandesas,
    ArabiaSaudita,
    Argelia,
    Argentina,
    Armenia,
    Aruba,
    Australia,
    Austria,
    Azerbaijao,
    Bahamas,
    Bahrein,
    Bangladesh,
    Barbados,
    Belarus,
    Belgica,
    Belize,
    Benin,
    Bermudas,
    Bolivia,
    BosniaHerzegovina,
    Botsuana,
    Brasil,
    Brunei,
    Bulgaria,
    BurkinaFasso,
    Burundi,
    Butao,
    CaboVerde,
    Camaroes,
    Camboja,
    Canada,
    Cazaquistao,
    Chade,
    Chile,
    China,
    Chipre,
    Cingapura,
    Colombia,
    Congo,
    CoreiaDoNorte,
    CoreiaDoSul,
    CostaDoMarfim,
    CostaRica,
    CroaciaHrvatska,
    Cuba,
    Dinamarca,
    Djibuti,
    Dominica,
    Egito,
    ElSalvador,
    EmiradosArabesUnidos,
    Equador,
    Eritreia,
    Eslovaquia,
    Eslovenia,
    Espanha,
    EstadosUnidos,
    Estonia,
    Etiopia,
    Fiji,
    Filipinas,
    Finlandia,
    Franca,
    Gabao,
    Gambia,
    Gana,
    Georgia,
    Gibraltar,
    GraBretanhaReinoUnido,
    Granada,
    Grecia,
    Groelandia,
    Guadalupe,
    Guam,
    Guatemala,
    Guernsey,
    Guiana,
    GuianaFrancesa,
    Guine,
    GuineEquatorial,
    GuineBissau,
    Haiti,
    Holanda,
    Honduras,
    HongKong,
    Hungria,
    Iemen,
    IlhaBouvet,
    IlhadoHomem,
    IlhaNatal,
    IlhaPitcairn,
    IlhaReuniao,
    IlhasAland,
    IlhasCayman,
    IlhasCocos,
    IlhasComores,
    IlhasCook,
    IlhasFaroes,
    IlhasFalkland,
    IlhasGeorgiadoSuleSandwichdoSul,
    IlhasHeardeMcDonald,
    IlhasMarianasdoNorte,
    IlhasMarshall,
    IlhasMenoresdosEstadosUnidos,
    IlhasNorfolk,
    IlhasSeychelles,
    IlhasSolomao,
    IlhasSvalbardeJanMayen,
    IlhasTokelau,
    IlhasTurkseCaicos,
    IlhasVirgensEstadosUnidos,
    IlhasVirgensInglaterra,
    IlhasWalliseFutuna,
    india,
    Indonesia,
    Ira,
    Iraque,
    Irlanda,
    Islandia,
    Israel,
    Italia,
    Jamaica,
    Japao,
    Jersey,
    Jordania,
    Kenia,
    Kiribati,
    Kuait,
    Laos,
    Latvia,
    Lesoto,
    Libano,
    Liberia,
    Libia,
    Liechtenstein,
    Lituania,
    Luxemburgo,
    Macau,
    Macedonia,
    Madagascar,
    Malasia,
    Malaui,
    Maldivas,
    Mali,
    Malta,
    Marrocos,
    Martinica,
    Mauricio,
    Mauritania,
    Mayotte,
    Mexico,
    Micronesia,
    Mocambique,
    Moldova,
    Monaco,
    Mongolia,
    Montenegro,
    Montserrat,
    Myanma,
    Namibia,
    Nauru,
    Nepal,
    Nicaragua,
    Niger,
    Nigeria,
    Niue,
    Noruega,
    NovaCaledonia,
    NovaZelandia,
    Oma,
    Palau,
    Panama,
    PapuaNovaGuine,
    Paquistao,
    Paraguai,
    Peru,
    PolinesiaFrancesa,
    Polonia,
    PortoRico,
    Portugal,
    Qatar,
    Quirguistao,
    RepublicaCentroAfricana,
    RepublicaDemocraticadoCongo,
    RepublicaDominicana,
    RepublicaTcheca,
    Romenia,
    Ruanda,
    Russia,
    SaaraOcidental,
    SaintVincenteeGranadinas,
    SamoaAmericana,
    SamoaOcidental,
    SanMarino,
    SantaHelena,
    SantaLucia,
    SaoBartolomeu,
    SaoCristovaoeNevis,
    SaoMartim,
    SaoTomeePrincipe,
    Senegal,
    SerraLeoa,
    Servia,
    Siria,
    Somalia,
    SriLanka,
    StPierreAndMiquelon,
    Suazilandia,
    Sudao,
    Suecia,
    Suica,
    Suriname,
    Tadjiquistao,
    Tailandia,
    Taiwan,
    Tanzania,
    TerritorioBritanicodoOceanoindico,
    TerritoriosdoSuldaFranca,
    TerritoriosPalestinosOcupados,
    TimorLeste,
    Togo,
    Tonga,
    TrinidadandTobago,
    Tunisia,
    Turcomenistao,
    Turquia,
    Tuvalu,
    Ucrania,
    Uganda,
    Uruguai,
    Uzbequistao,
    Vanuatu,
    Vaticano,
    Venezuela,
    Vietna,
    Zambia,
    Zimbabue
}
